<template>
  <div class="prism">
    <div class="flex flex-col gap-6 !px-6">
      <form
        class="mx-auto rounded-3xl !border !border-secondary bg-white py-8 px-3 flex flex-col gap-4 items-start w-4/5"
        @submit.prevent="onFormSubmit"
        v-show="!isFormSubmitted"
      >
        <div class="flex flex-col gap-6 w-100">
          <div v-for="option in useCaseOptions" class="custom-control custom-radio use-case-entry">
            <input type="radio" :id="option" :value="option" v-model="surveyAnswers.useCase" class="cursor-pointer" />
            <div class="flex flex-col items-start align-start ml-2">
              <label :for="option" class="mb-0 cursor-pointer">
                <span>
                  {{ I18n.t(`checkout.survey.use_case.options.${option}.title`) }}
                </span>
                <p class="text-xs text-typo-secondary mb-0" v-if="option !== 'other'">
                  {{ I18n.t(`checkout.survey.use_case.options.${option}.description`) }}
                </p>
              </label>
            </div>
            <div class="spacer"></div>
            <BasicInput
              v-if="option === 'other' && surveyAnswers.useCase === 'other'"
              class="pl-2 mt-2 w-100"
              @update:modelValue="updateOtherDescription"
              :model-value="surveyAnswers.useCaseOtherDescription"
              :label="I18n.t('checkout.survey.use_case.options.other.description')"
              :additional-attributes="{ maxlength: 100 }"
            />
          </div>
        </div>
        <Button
          type="submit"
          :disabled="
            !surveyAnswers.useCase || (surveyAnswers.useCase == 'other' && !surveyAnswers.useCaseOtherDescription)
          "
          class="w-100"
        >
          {{ I18n.t("checkout.survey.submit") }}
        </Button>
        <p
          v-html="
            I18n.t('checkout.survey.foot_note', {
              privacy_policy: `<a target='_blank' href='/privacy' >${I18n.t('footer.links.privacy_policy')}</a>`,
            })
          "
          class="text-2xs text-typo-secondary m-0 !mt-2 text-center mx-auto w-3/4"
        ></p>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject, reactive, ref } from "vue";
import { Button, BasicInput } from "prism";

import { rbgPurchaseSurveyFormSubmittedV2V100 } from "kaleido-event-tracker";
import Rails from "@rails/ujs";
const I18n = inject("I18n");

defineProps<{ useCaseOptions: string[] }>();

const isFormSubmitted = ref(false);
const emit = defineEmits(["submittedSurvey"]);

const surveyAnswers = reactive({
  useCase: null,
  useCaseOtherDescription: null,
});

const updateOtherDescription = (val) => {
  surveyAnswers.useCaseOtherDescription = val;
};

const onFormSubmit = () => {
  if (surveyAnswers.useCase === "other") {
    const valid = validateOtherTextField();
    if (!valid) return;
  }
  const formData = new FormData();
  formData.set("use_case", surveyAnswers.useCase);
  formData.set("use_case_other_description", surveyAnswers.useCaseOtherDescription);
  fetch("/checkouts/post_purchase_survey", {
    headers: {
      "x-csrf-token": Rails.csrfToken(),
    },
    method: "POST",
    body: formData,
  });

  // track survey form submitted event
  rbgPurchaseSurveyFormSubmittedV2V100({
    use_case_selected: surveyAnswers.useCase,
    optional_free_text: surveyAnswers.useCaseOtherDescription,
  });

  emit("submittedSurvey");
  isFormSubmitted.value = true;
};

const validateOtherTextField = () => {
  const trimmed = surveyAnswers.useCaseOtherDescription.trim();
  if (trimmed.length === 0) {
    surveyAnswers.useCaseOtherDescription = "";
    return false;
  }

  if (trimmed.length > 100) {
    surveyAnswers.useCaseOtherDescription = surveyAnswers.useCaseOtherDescription.slice(0, 99);
  }

  return true;
};
</script>

<style scoped>
.use-case-entry {
  width: 100%;
  display: grid;
  grid-template-columns: min-content auto;
}

form {
  max-width: 48rem;
}
</style>
